import { useTranslation } from 'react-i18next';

export default function ContactHero() {
  const { t } = useTranslation();

  return (
    <section className="relative pt-32 pb-20 overflow-hidden bg-[#0F2340]">
      {/* Background image overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/1d92873fe2056a4358a4b1259864f284.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F2340]/80 via-[#0F2340]/60 to-[#0F2340]" />

      <div className="relative max-w-7xl mx-auto px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-sky-500/20 border border-sky-400/30 rounded-full px-4 py-1.5 mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-customer-service-2-line text-sky-400 text-sm"></i>
          </div>
          <span className="text-sky-300 text-xs font-semibold tracking-widest uppercase">
            {t('contact_hero_badge')}
          </span>
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-5">
          {t('contact_hero_title1')}{' '}
          <span className="text-sky-400">{t('contact_hero_title2')}</span>
        </h1>

        {/* Subtitle */}
        <p className="text-slate-300 text-lg max-w-2xl mx-auto leading-relaxed mb-10">
          {t('contact_hero_desc')}
        </p>

        {/* Quick contact chips */}
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="tel:+15615122820"
            className="flex items-center gap-2.5 bg-white/10 hover:bg-sky-500/30 border border-white/20 hover:border-sky-400/50 rounded-full px-5 py-2.5 text-white text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-sky-400"></i>
            </div>
            +1 (561) 512-2820
          </a>
          <a
            href="mailto:info@orpminvestment.com"
            className="flex items-center gap-2.5 bg-white/10 hover:bg-sky-500/30 border border-white/20 hover:border-sky-400/50 rounded-full px-5 py-2.5 text-white text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-fill text-sky-400"></i>
            </div>
            info@orpminvestment.com
          </a>
          <div className="flex items-center gap-2.5 bg-white/10 border border-white/20 rounded-full px-5 py-2.5 text-slate-300 text-sm font-medium whitespace-nowrap">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-time-line text-sky-400"></i>
            </div>
            Mon–Fri 8am–6pm · Sat 9am–3pm
          </div>
        </div>
      </div>
    </section>
  );
}
